export enum PRODUCT_PRESENTATION_SERVICE_ENDPOINTS {
  GET_COLLECTION_PRODUCTS_HIERARCHY = 'collection/product-hierarchy',
  GET_PRODUCTS = 'collection/products',
  GET_FILTER_ATTRIBUTES = 'collection/listFilterAttributes',
  COLLECTION = 'collection',
  ORDER = 'order',
  WISHLIST = 'wishlist',
  PRICE = 'price',
  ENHANCED_CREATE_ORDER = 'core/showroom'
}
